<template>
 
  <div class="report_wrap" ref="turtor">
    
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
     <!-- 头部banner图片 -->
     <img class="bannerImgcss0" src="../../assets/w/img3/rencaijiaoliu/rencaizhaopin-bg.png" />

    <!-- 二级菜单切换 -->
     <div class="mainbody menus">
      <a href="/home"><i class="el-icon-s-home"></i></a> / <a>搜索页</a><span @click="cengji=1" v-if="cengji == 2"> / <a style="font-size: 1rem;">返回列表</a></span>
      <span v-if="cengji == 2" class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>
  
    </div>
      
     <div style="width: 65vw;margin: 0 auto;margin-bottom: 1rem;"> 
      <div style="margin-top: 15px;">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"  @click="searchArticleFn" >搜索</el-button>
          
        
        </el-input>
      </div>
      
     </div>

      <div v-if="cengji == 1">
        <div class="divAll"  v-for="(item, index) in columnListNow" :key="item.id" >
          <div class="divL" @click="goArticleDetail(item)" > 
            
            <a class="blockA"  :class="{ 'blockA1': isHover &&(nowIndex == index) }" @mouseover="isHover = true;nowIndex=index"  @mouseleave="isHover = false;nowIndex=null">
                        <span>{{ item.createDate.split('-')[2] }}</span>
                        <span>{{ item.createDate.split('-')[0] }}-{{ item.createDate.split('-')[1] }}</span>
            </a>
          </div>
          <div class="divR" @click="goArticleDetail(item)"  :class="{ 'activedivR': isHover &&(nowIndex == index) }" @mouseover="isHover = true;nowIndex=index"  @mouseleave="isHover = false;nowIndex=null">
            <h1 >{{ item.title }}
              <span class="cursorRightBtn"  :class="{ 'cursorRightBtnActive': isHover &&(nowIndex == index) }" @mouseover="isHover = true;nowIndex=index"  @mouseleave="isHover = false;nowIndex=null" ><i class="el-icon-arrow-right"></i></span>
            </h1>
            <!-- <p  v-html="item.articleData.content1" class="details" ></p> -->
                      
          </div>
        </div>
      </div>
      
      
      <div class="change_page" v-if="cengji == 1 && columnListNow.length>0">
        <!-- 首页按钮 -->
        <el-button 
          class="pagination-btn first-last"
          :disabled="currentPage === 1"
          @click="handleFirstPage">
          首页
        </el-button>

        <!-- 分页组件 -->
        <el-pagination
          layout="prev, pager, next"
          :total="totalNum"
          :page-size="pageSize"
          :current-page="currentPage"
          background
          @current-change="pageChange"
        />

        <!-- 末页按钮 -->
        <el-button 
          class="pagination-btn first-last"
          :disabled="currentPage >= totalPage"
          @click="handleLastPage">
          末页
        </el-button>
      </div>

      <!-- 三级页面(详情界面) -->
      <div class="articleDetailDiv" v-if="cengji == 2">
       
          <h1 v-scroll-animate="'fly-in-bottomgy'" class="fontSizeTitle">{{ articleDetail.title }}</h1>
          <p class="fontcssxy0 fontSizeTtme" v-scroll-animate="'fly-in-bottomgy'">发布时间：{{ articleDetail.createDate.substring(0,16) }}   
            <span v-if="!!articleDetail.copyfrom" style="padding-left: 10px;padding-right:10px;">     来源：{{ articleDetail.copyfrom }}</span></p>
          <div  :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'" v-blank-link v-html="articleDetail.content" v-scroll-animate="'fly-in-bottomgy'"></div>
          <!-- 新增上下篇导航 -->
        <div class="detail-pagination">
          <div class="pagination-bg">
            <div class="prev-article">
              <template v-if="prevArticle">
                <span class="pagination-label">上一篇：</span>
                <a @click="goArticleDetail(prevArticle)" class="article-title">{{ prevArticle.title }}</a>
              </template>
              <template v-else>
                <span class="pagination-label">上一篇：</span>
                <span class="no-article">没有了</span>
              </template>
            </div>
            <div class="next-article">
              <template v-if="nextArticle">
                <span class="pagination-label">下一篇：</span>
                <a @click="goArticleDetail(nextArticle)" class="article-title">{{ nextArticle.title }}</a>
              </template>
              <template v-else>
                <span class="pagination-label">下一篇：</span>
                <span class="no-article">没有了</span>
              </template>
            </div>
          </div>
        </div>
      </div>
  </div>

  

</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import API from '@/api/index'
import moment from 'moment';
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import MouseWheel from '@better-scroll/mouse-wheel'
BScroll.use(Pullup)
BScroll.use(MouseWheel)
// import MediaList from '@/utils/mediaList.json'

export default {
  data() {
    return {
      fontsize:'default',
      input3:'',
      nowIndex:null,
      articleDetail:[],
      currentPage:1,
      totalNum:0,
      pageSize:9,
      cengji:1, // 当前页面层级
      typeObj:0, // 新闻类型
      nowTab:null,
     urlBase: process.env.VUE_APP_BASE_API,
      activeIndex: 0,
    
      columnList: [],
      columnListNow:[], // 二级页面列表
      isHover:false
     }
  },
  // 在 Vue 组件中定义过滤器
  filters: {
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString(); // 或者自定义格式
    }
  },
  components: {
    PCNavbar,
    MobileNavBar,
      
  },
  created() {
  
 },
  mounted() {
   
  },
  computed: {
    totalPage() {
       return Math.ceil(this.totalNum / this.pageSize); // 确保使用组件内pageSize
    },
    pageRange() {
      return Array.from({length: this.totalPage}, (_, i) => i + 1)
    },
    prevArticle() {
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index > 0 ? this.columnListNow[index - 1] : null;
    },
    nextArticle() {
      const index = this.columnListNow.findIndex(item => item.id === this.articleDetail.id);
      return index < this.columnListNow.length - 1 ? this.columnListNow[index + 1] : null;
    }
  },
  methods: {
    // 全局搜索
    async searchArticleFn() {
      try {
        let params={
          searchName:this.input3,
          pageNum:this.currentPage
        }
        const res = await API.searchArticle(params)
        this.cengji=1
         this.columnListNow=res.data.artList
         this.columnListNow.forEach(item=>{
            item.createDate= moment(item.createDate).format('YYYY-MM-DD')
           
         })
        
         this.totalNum=res.data.totalNum
         this.totalPage=res.data.totalPage

        } catch (error) {
        }
      },
    
      formatTime(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
    },
    getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },
    listVueFn(){
      this.cengji--
    },
    // 往二级页面跳转，传参
    golist(obj){
      this.cengji=1
      this.typeObj=obj
      this.getlist()
    },
     
    
    gocengji0(){
      this.cengji--
    },
    goMore(){
      this.cengji++
    },
    handleFirstPage() {
      if (this.currentPage !== 1) {
        this.pageChange(1)
      }
    },
    handleLastPage() {
      const last = this.totalPage
      if (this.currentPage !== last) {
        this.pageChange(last)
      }
    },
    pageChange(page) {
      if (page < 1 || page > this.totalPage) return;
    this.currentPage = page
    this.searchArticleFn()
  },
  
    // 获取三级页面详情页
   async goArticleDetail(obj) {
    
    this.cengji=2
    try {
       let objParams={
        artId:obj.id,
      }
      const res = await API.getArticleData(objParams)
      
      
      this.articleDetail=res.data.list[0]
      if (this.currentPage !== Math.ceil((this.columnListNow.indexOf(obj) + 1) / this.pageSize)) {
          await this.getlist();
        }
      this.nowTab=res.data.list[0].name
      
      // 回到顶部
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      console.log('###', this.nowTab)
      console.log('获取成功', res.data.list)
    } catch (error) {
      console.error('获取失败', error)
    }
    },
    handleNewsDetails(url) {
      // this.$router.push(`/news_detail/${id}`)
      window.open(url)
    },
    
   
  },
  watch: {
    
  },
}
</script>

<style lang="scss" scoped>
.detail-pagination {
    //width: 90%;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #015293;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }

.mainbody{
  width: 100%;
 }
//  .menus{
//   padding:1rem;
//   padding-left: 0;
//   font-size:1rem;
//  }
.report_wrap {
  padding-bottom: 8rem;
  // margin-top: -1rem;
  background: #ffffff;
  .card_list {
    flex-wrap: wrap;

    .card_item {
      display: flex;
      margin-top: 1rem;
      padding: 20px;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        box-shadow: 10px 10px 20px rgba($color: #000000, $alpha: 0.2);
        transform: scale(1.05);
      }

      .item_left {
        flex: 1;

        img {
          width: 90%;
          height: 100%;
          max-height: 350px;
          object-fit: cover;
          -webkit-user-drag: none;
        }
      }

      .item_right {
        flex: 1;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        h1 {
          color: #666;
          font-size: 28px;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        p {
          font-size: 13px;

          @media screen and (max-width: 768px) {
            &:nth-child(2) {
              display: none;
            }

            font-size: 13px;
          }
        }
      }
    }
  }
}

 

.book_list_speial {
  padding-top: 16px;
  width: 70%;
  margin: 0 auto;
}

.scroll_btn2 {
  @media screen and (max-width:768px) {
    width: 280px;
    height: 35px;
    background: #fff !important;
    color: #151514 !important;
    border: solid 1px #333333 !important;
    font-size: 12px;
  }
}
   
.menu001{
  margin: 0 auto;
  width: 90%;
  margin-bottom: 1rem;
  // background: #d266ae;
 
  .el-col{
    text-align: center;
    // border: 1px solid #2091d3;
    margin-bottom: 0.5rem;
    padding:1rem 0.5rem;
    font-size: 1rem;
  }
   
}

.menucss0 .el-col:nth-child(1){
  background: #015293;
  color: #ffffff;
}
.menucss1 .el-col:nth-child(2){
  background: #015293;
  color: #ffffff;
}
.menucss2 .el-col:nth-child(3){
  background: #015293;
  color: #ffffff;
}
.menucss3 .el-col:nth-child(4){
  background: #015293;
  color: #ffffff;
}
.menucss4 .el-col:nth-child(5){
  background: #015293;
  color: #ffffff;
}
.el-card__body{
  position: relative;
  display: flex;
  .image{
    flex: 35%;
  }
  .zhuan_content {
       flex: 65%;
       padding-left:30px;
       cursor: pointer;
      @media screen and (max-width:768px) {
        pad: 10px;
      }

      h1 {
        min-height:2rem;
        margin-top:1rem;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 1.1rem;

        @media screen and (max-width:768px) {
          min-height: 55px;
        }
      }

      .btn {
        background: #333333;
        float: right;
        color: #fff;
        margin-top: 20px;
        width: 80PX;
        height: 35PX;
        border-radius: 20PX;

        @media screen and (max-width:768px) {
          font-size: 12px;
        }
      }
 
    }
  .goDetailcss0{
    position: absolute;
    top: 1px;
    left: 50%;
    transform: translateX(-50%);
    background: #015293;
    color: #ffffff;
    padding:0.5rem 1rem;
  }
  
}
.cssCol{
  cursor: pointer;
}
.change_page{
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
}

.articleDetailDiv{
  width: 90vw;
    margin: 0 auto;
    padding:0 70px 50px;
    border:  1px solid #e5e5e5;
  margin-bottom: 1rem;
  
  h1{
    width: 80%;
    margin:0 auto;
    margin-bottom: 1rem;
    border-bottom: 1px solid #999999;
    text-align: center;
    padding:1rem 0;
  }
  p{
    text-align: center;
  }
  div.contentcss0{
    
    margin: 0 auto;
    margin-top: 1rem;
    font-size: 1rem;
    line-height: 1rem;
    img{
      width: 60% !important;
      height: auto !important;
    }
  }
  // div.contentcss0 ::v-deep p{
  //   font-size: 1rem !important;  /* 覆盖内联样式 */
  //   line-height: 1rem;
  //   margin:0 !important;
  //   // margin-top: 0 !important;
  //   color: #333 !important;
  // }
}


.procard_btn {
  width: 100%;
  display: flex;
  .mobileGkmenu{
    display:none;
  }
  .procard_item {
    flex: 1;
    height: 60px;
    background: rgba(255,255,255,1);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:1.1rem;
    position: relative;
    cursor: pointer;
    color: #015293;
    transition: all 0.3s ease;
    @media screen and (max-width: 768px) {
      display:none;
      height: 60px;
      text-align: center;
      font-size: 12px;
      color: #015293;
      transition: all 0.3s ease;
    }
  }
  .active {
    color: #fff;
    transform: translateY(-3px);
    // background: #2091d3;
    // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
    background: #015293;

    // background: linear-gradient(135deg, #0649b8, #f5f8f8);
    font-weight: bold;
    &::before {
      // content: '▲';
      position: absolute;
      color: #015293;
      font-size: 40px;
      transform: rotateX(180deg);
      bottom: -27px;
    }
  }
  @media screen and (max-width: 768px) {
    
      .mobileGkmenu{
        display:block;
        width:100%;
        // height:10rem;
        .mobileGkdiv{
          background: rgba(255,255,255,1);
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
          margin:0.25rem;
          line-height:2rem;
          text-align:center;
        }
        .active {
          color: #fff;
          // background: linear-gradient(135deg, #0649b8, #03d2c5);
          // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
          background: #015293;
          box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
          font-weight: bold;
          &::before {
            content: '';
          }
        }
      }
  }
}

.divAll{
  width: 90%;
  margin: 0 auto;
  min-height: 10vh;
  background: #f5f5f5;
  margin-bottom: 1rem;
  display: flex;
  div.divL{
    width: 7vw;
    min-width: 80px;
    height: 6rem;
    // min-height: 80px;
    margin-right:3vh;
    background: rgb(242, 241, 241);
    @media screen and (max-width: 768px) {
      width: 90px;
      height: 90px;
    }
    .blockA{
      width:100%;
      height: 100%;
      display: block;
      text-align: center;
      color: #666666;
      span{
        display: inline-block;
        display: block;
        width: 100%;
       
        font-size: 1.2vw;
        @media screen and (max-width: 768px) {
          margin-top:2px;
          font-size: 1.2vw;
        }
      }
      span:first-child{
        font-size: 3rem;
        // margin-top:10px;
        height: 3.5rem;
        font-size: 2.8vw;
        @media screen and (max-width: 768px) {
          margin-top:20px;
          font-size: 3.5vh;
        }
      }
      
    }
    .blockA:hover{
      background: #015293;
      color: #ffffff;
    }
    .blockA1{
      background: #015293;
      color: #ffffff;
    }
  }
  div.divR{
    flex: 1;
    // background: #cbcbcb;
    display:flex;
    flex-direction:column;
    justify-content:center;
    h1{
      font-size: 1.1rem;
      width: 100%;
      margin-bottom: 1vh;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      @media screen and (max-width:768px) {
        font-size: 2.5vh;
        }
    }
    .details {
        width: 100%;
        font-size: 1rem;
        text-indent: 2rem;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        @media screen and (max-width:768px) {
          // font-size: 13px;
        }
      }
      // .details ::v-deep p {
      //   font-size: 2.2vh !important;  /* 覆盖内联样式 */
      //   margin:0 !important;
      //   // margin-top: 0 !important;
      //   font-weight: 100 !important;
      //   color: #666666 !important;
      //   span{
      //     font-size: 2.2vh !important;  /* 覆盖内联样式 */
      //   }
      // }
     
  }
  .activedivR{
    cursor: pointer;
    color: #015293;
    .details ::v-deep p {
      color: #015293 !important;
    }
  }
}
.containerDiv{
  // margin-bottom:8rem;
  @media screen and (max-width: 768px) {
    margin-bottom:0;
  }
}
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
} 

.mainbody{
  width: 90%;
  margin:0 auto;
  background:#ffffff;
 }
//  .menus{
//   padding:1rem;
//   font-size:1rem;
//   padding-left:0;
//  }
 .Lmenu{
  margin-top:1rem;
  // padding:1rem;
  margin-bottom:0.5rem;
  font-size:1rem;
  background:#eee;
  text-align:center;
  a{
    display: block;
    width: 100%;
    padding:1rem;
    // background: #d38220;
    color:#666;
  }
 }
 .active{
    background:#2091d3;
    a{
      color:#ffffff;
   }
  }
 .Rcontent{
  display:flexbox;
  padding:1rem;
  padding-top:0;
  background:#ffffff;
  margin-left:3.5rem;
  @media screen and (max-width: 768px) {
    margin-left:0;
  }
    ul{
      li{
        list-style:none;
        // padding:1rem;
        line-height:1rem;
        border-bottom:1px solid #e5e5e5;
        display:flex;
        .Rtime{
          flex:5%;
          padding:0.8rem;
          background:#e5e5e5;
          font-size:1rem;
          font-weight:bold;
          color:#dab773;
        }
        .Rtitle{
          flex:85%;
          padding:1.3rem;
          font-size:0.9rem;
          a{
            color:#333;
          }
        }
      }
      li.lastLi{
        border-bottom:none;
      }
    }
 }
 .articleDetailDiv{
    width: 90%;
    margin: 0 auto;
    margin-bottom: 1rem;
    // border: 1px solid #999999;
    h1{
      width: 80%;
      margin:0 auto;
      margin-bottom: 1rem;
      border-bottom: 1px solid #999999;
      text-align: center;
      padding:1rem 0;
    }
    p{
      text-align: center;
    }
    // 重置字体样式001
    div.contentcss0 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto !important;
      // margin-top: 1rem;
      font-size:18PX !important;
      line-height: 2em !important;
      text-indent:2em !important;
      text-align: justify !important;
      word-break: break-all !important;
      color: #000000;
      // text-align: left !important;
      @media (min-width: 0px) and (max-width: 991px) {
      span img{
          margin-left: -28px!important;
        }
      }
    }
  }
    // 重置图片样式 002
  div.contentcss0  img {
    border: var(--img-border, none) !important;
    width: var(--img-width, auto) !important;
    height: var(--img-height, auto) !important;
  }

  /* 使用深度选择器（Vue 2/3 兼容写法） */
  .contentcss0 >>> img,.contentcss0 ::v-deep img,.contentcss0 :deep(img) {
    border: none !important; /* 移除边框 */
    padding: 0 !important;
    // margin: 0!important;
    box-shadow: none !important;
    display: block;
    margin:0 auto !important;
    width: 80% !important;
  }

  .change_page{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
  }
 
</style>
<style lang="scss" scoped> 
::v-deep .el-input__inner{
  padding:2rem 1rem;
  font-size: 1.1rem;
}
::v-deep .el-input-group__append, .el-input-group__prepend{
  padding:0 5rem;
  background-color:#1A52EE;
  color: #ffffff;
  font-size: 1.5rem;
  @media screen and (max-width: 768px) {
    padding:0 1rem;
    }
}
 

.articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 20PX !important;
        color: #000000;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 16PX !important;
        color: #000000;
    }
}
</style>